import { Input } from '~/primitives/input';
import { useFieldContext } from '~/util/hooks/useFormContext';
import { FieldLabelWithError } from './FieldLabelWithError';
import type { FieldWithErrorProps } from './FieldLabelWithError';
import { cn } from '~/util';
import { useDisableFormContext } from '../DisableContext';

export function URLField({
    placeholder,
    classname,
    ...labelProps
}: {
    placeholder: string;
    classname?: string;
} & FieldWithErrorProps) {
    const field = useFieldContext<string | null>();
    const disabled = useDisableFormContext();
    return (
        <FieldLabelWithError<string | null> {...labelProps}>
            <Input
                className={cn('field-sizing-content max-w-md', classname)}
                id={field.name}
                placeholder={placeholder}
                type="url"
                maxLength={300}
                required={labelProps.required}
                value={field.state.value ?? ''}
                onChange={(e) =>
                    field.handleChange(
                        e.target.value === '' ? null : e.target.value,
                    )
                }
                disabled={disabled}
            />
        </FieldLabelWithError>
    );
}
